import { drawerClasses } from '@mui/material/Drawer';
import { InvoiceCategoryFilter } from '@treadinc/horizon-api-spec';
import { useCallback, useState } from 'react';

import { Drawer } from '~components/Drawer/src/ui';
import { Settlement } from '~hooks/useSettlements/models';

import SettlementSheetContent from './SettlementSheetContent';

interface SettlementSheetProps {
  category?: InvoiceCategoryFilter;
  isOpen: boolean;
  onClose: () => void;
  onSettlementChange: (settlement: Settlement) => void;
  onVoidClick: (settlement: Settlement) => void;
  settlement: Settlement | null;
}

export default function SettlementSheet({
  category,
  isOpen,
  onClose,
  onSettlementChange,
  onVoidClick,
  settlement,
}: SettlementSheetProps) {
  const [isBusy, setIsBusy] = useState(false);

  const handleClose = useCallback(() => {
    if (!isBusy) {
      onClose();
    }
  }, [isBusy, onClose]);

  return (
    <Drawer
      onClose={handleClose}
      open={isOpen && settlement !== null}
      sx={{ [`& .${drawerClasses.paper}`]: { maxWidth: '1200px', width: '80%' } }}
    >
      {settlement && (
        <SettlementSheetContent
          key={settlement.id}
          category={category}
          onBusyChange={setIsBusy}
          onClose={handleClose}
          onSettlementChange={onSettlementChange}
          onVoidClick={onVoidClick}
          settlement={settlement}
        />
      )}
    </Drawer>
  );
}
